import { useSelector } from 'react-redux';

import { NotificationBadge } from 'src/components/NotificationBadge';
import { useNotificationBadgeData } from 'src/hooks/useNotificationBadgeData';
import { useNotificationsCounts } from 'src/hooks/useNotificationsCount';
import {
  SIDEBAR_PAGES_TO_LOAD,
  useGetInboxNotificationsQuery,
} from 'src/services/api/inboxApi';
import { RootState } from 'src/store';

export const InboxNotificationBadge = () => {
  const { data: inboxNotifications } = useGetInboxNotificationsQuery(
    SIDEBAR_PAGES_TO_LOAD,
  );
  const cus = useSelector((state: RootState) => state.clients.clients);
  const ius = useSelector((state: RootState) => state.users.internalUsers);
  const companyDataMap = useSelector(
    (state: RootState) => state.clients.companyDataMap,
  );
  const { unreadNotificationCount } = useNotificationsCounts(
    inboxNotifications || [],
    [...cus, ...ius],
    companyDataMap,
  );

  const { backgroundColor, textColor } = useNotificationBadgeData(true);

  return (
    <NotificationBadge
      showZero={false}
      isSidebar
      content={unreadNotificationCount}
      backgroundColor={backgroundColor}
      textColor={textColor}
    />
  );
};
